/**
 * 协商历史
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/8/31      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import "./index.less";
import moment from "moment";
import {symbolMoneyUtil} from '@utils/utils';
import FileList from "./FileList";
import Lang from "@components/Lang/Lang"

class History extends React.Component{
    constructor(props) {
        super(props);
    }

    getTitle(status=10){
        // 10:发起,20:不同意,30:同意,40:已汇款
        let title = '';
        switch (status) {
            case '10':
                title = Lang({
                id: 'FaQiPeiChangFangAn',
                default:`发起赔偿方案`,
            })+'!';
                break;
            case '20':
                title = Lang({
                    id: 'ShenHeBuTongGuo',
                    default:`审核不通过`,
                })+'!';
                break;
            case '30':
                title = Lang({
                id: 'YiTongYiPeiChang',
                default:`已同意赔偿`,
            })+'!';
                break;
            case '40':
                title = Lang({
                id: 'YiHuiKuan',
                default:`已汇款`,
            })+'!';
                break;
        }
        return title;
    }

    getContent(item){
        // 10:发起,20:不同意,30:同意,40:已汇款
        const status = item.status;
        let content = ``;
        let model = this.props.model;
        let countMoney = symbolMoneyUtil(item.refundAmountTotal,item.currencySymbol);
        let money = symbolMoneyUtil(item.refundAmount,item.currencySymbol);
        let text = model.mgPoInfoVO.skuCount>1?'PCS':__getServerDictItem("unit_type." + model.mgPoInfoVO.skuUnit);
        switch (status) {
            case '10':
                let tip;
                //10:优惠券,20:现金
                if(item.claimType==10){
                    //`有问题产品数量 ${item.quantity} ${text}，赔付价值 ${countMoney} 的优惠券，有效期 ${item.effectiveDays||'-'} 天。`
                    tip = Lang({
                        id: 'YouWenTiChanPinShuLiangN1',
                        default:`有问题产品数量 ${item.quantity} ${text}，赔付价值 ${countMoney} 的优惠券，有效期 ${item.effectiveDays||'-'} 天。`,
                        params:[item.quantity,text,countMoney,item.effectiveDays||'-']
                    });
                }else{
                    //`售后产品数量 ${item.quantity} ${text}，赔付 ${countMoney} 的现金，请上传现金申请表单。`
                    tip = Lang({
                        id: 'YouWenTiChanPinShuLiangN2',
                        default:`售后产品数量 ${item.quantity} ${text}，赔付 ${countMoney} 的现金，请上传现金申请表单。`,
                        params:[item.quantity,text,countMoney]
                    })
                }
                content = <div>
                    <p>{tip}</p>
                    <div className="mt_12">{item.remark}</div>
                    <FileList list={item.consultFileList}></FileList>
                </div>;
                break;
            case '20':
                content = item.remark;
                break;
            case '30':
                //10:优惠券,20:现金
                if(item.claimType==10){
                    //破损
                    if(model.type=='damaged'){
                        content = Lang({
                            id: 'YouWenTiChanPinShuLiangN',
                            default:`有问题产品数量 ${item.quantity} ${text}，已赔付价值 ${countMoney} 的优惠券，有效期 ${item.effectiveDays||'-'} 天，请尽快使用。`,
                            params:[item.quantity,text,countMoney,item.effectiveDays||'-']
                        });
                    }else{
                        content = Lang({
                            id: 'YiPeiFuJiaZhiNDeYouHuiQuan',
                            default:`已赔付价值 ${countMoney} 的优惠券，有效期 ${item.effectiveDays||'-'} 天，请尽快使用。`,
                            params:[countMoney,item.effectiveDays||'-']
                        });
                    }
                }else{
                    //破损
                    if(model.type=='damaged'){
                        content = Lang({
                            id: 'YouWenTiChanPinShuLiangN3',
                            default:`有问题产品数量 ${item.quantity} ${text}，已通过现金方式赔付 ${countMoney}，请留意银行收款信息！`,
                            params:[item.quantity,text,countMoney]
                        });
                    }else{
                        content = Lang({
                            id: 'YiTongGuoXianJin',
                            default:`已通过现金方式赔付 ${countMoney}，请留意银行收款信息！`,
                            params:[countMoney]
                        });
                    }
                }
                break;
            case '40':
                content = Lang({
                    id: 'YiHuiKuanDaoNiTianXieDeYinHan',
                    default:`已汇款到你填写的银行账户，请留意银行收款信息！`});
                break;
        }
        return content;
    }

    render(){
        let {consultList=[]} = this.props.model;
        return (
            <div className="history__wrap">
                <div className="history__header">
                    <span className="title">
                        {Lang({id:'XieShangLiShi',default:'协商历史'})}
                    </span>
                </div>
                <div className="history__main" style={{maxHeight:this.props.height}}>
                    <ul>
                        {
                            consultList.map((item,index)=>{
                                if(item.businessPlatform == 'mg'){
                                    let content = this.getContent(item)||'-';
                                    return <li className="item" key={index}>
                                        <img src={item.essaoneLogoUrl} className="img" alt=""/>
                                        <div className="content">
                                            <p className="time">{item.createTime?moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</p>
                                            <div className="content-box mg-content-box">
                                                <p className="ui-title">{this.getTitle(item.status)}</p>
                                                <div className="ui-text">
                                                    {content}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                }else{
                                    return <li className="item" key={index}>
                                        <img src={item.buyerLogoUrl||'http://oss.essa.cn/de02d674-e07e-4308-b56e-57c4feb75ee4.png'} className="img" alt=""/>
                                        <div className="content">
                                            <p className="time">{item.createTime?moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</p>
                                            <div className="content-box">
                                                <div className="ui-text">
                                                    {item.remark||'-'}
                                                </div>
                                                <FileList list={item.consultFileList}></FileList>
                                            </div>
                                        </div>
                                    </li>
                                }
                            })
                        }
                    </ul>
                </div>
            </div>
        )
    }
}

History.defaultProps = {
    height:'inherit',
    model: {}
}

History.propTypes = {

}
export default History;
